import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon: Icon, name, ...props }) => {
  if (Icon) {
    return <Icon {...props} />;
  }
  
  if (name) {
    // Lazy load icon by name if needed
    try {
      return <Icon {...props} />;
    } catch (e) {
      console.warn(`Icon ${name} not found`);
    }
  }
  
  // Fallback icon
  return <FiAlertTriangle {...props} />;
};

export default SafeIcon;